<template>
  <div class="c-current-step">
    <div class="c-current-step__current">
      {{ current }}
    </div>
    <div class="c-current-step__max">&nbsp;/ {{ max }}</div>
  </div>
</template>

<script>
export default {
  name: "CurrentStep",
  props: ["current", "max"]
};
</script>

<style scoped>
.c-current-step {
  display: flex;
  align-items: flex-end;
}
.c-current-step__current {
  font-size: 22px;
  font-weight: bold;
}
.c-current-step__max {
  color: #acacac;
}
</style>
